import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBuilding, 
  faStore, 
  faBriefcase, 
  faClock, 
  faFileAlt, 
  faQuestionCircle, 
  faComment,
  faSpinner,
  faExclamationTriangle,
  faFile
} from '@fortawesome/free-solid-svg-icons';
import './ApplicationDetail.css'

const ApplicationDetail = ({ dashboard }) => {
  const { applicationId } = useParams();
  const [application, setApplication] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchApplication = async () => {
      setLoading(true);
      setError(null);
      
      let baseUrl; 
      try {
        baseUrl = `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/applications/${applicationId}`;
      
        const response = await fetch(baseUrl, {
          method: 'GET',
          credentials: 'include',
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch application details: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        
        if (data.success && data.data) {
          setApplication(data.data);
        } else {
          setApplication(data);
        }
      } catch (error) {
        console.error("Error fetching application details:", error.message);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchApplication();
  }, [applicationId]);

  if (loading) {
    return (
      <div className="application-detail__container">
        <div style={{ textAlign: 'center', padding: '4rem 2rem' }}>
          <FontAwesomeIcon icon={faSpinner} spin style={{ fontSize: '3rem', marginBottom: '1rem', color: '#fb5424' }} />
          <h2 style={{ color: '#fb5424', marginBottom: '1rem' }}>Cargando detalles...</h2>
          <p style={{ color: '#6c757d' }}>Obteniendo información de la postulación</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="application-detail__container">
        <div style={{ textAlign: 'center', padding: '4rem 2rem' }}>
          <FontAwesomeIcon icon={faExclamationTriangle} style={{ fontSize: '3rem', marginBottom: '1rem', color: '#e53e3e' }} />
          <h2 style={{ color: '#e53e3e', marginBottom: '1rem' }}>Error al cargar</h2>
          <p style={{ color: '#6c757d' }}>{error}</p>
        </div>
      </div>
    );
  }

  if (!application) {
    return (
      <div className="application-detail__container">
        <div style={{ textAlign: 'center', padding: '4rem 2rem' }}>
          <FontAwesomeIcon icon={faFile} style={{ fontSize: '3rem', marginBottom: '1rem', color: '#fb5424' }} />
          <h2 style={{ color: '#fb5424', marginBottom: '1rem' }}>No se encontró la postulación</h2>
          <p style={{ color: '#6c757d' }}>La postulación que buscas no existe o ha sido eliminada</p>
        </div>
      </div>
    );
  }

  return (
    <div className="application-detail__container">
      <h1><FontAwesomeIcon icon={faFileAlt} /> Postulación</h1>
      
      <div className="application-detail__offer-container">
        <div className="application-detail__offer-col-1">
          <div className="application-detail__offer-info-container"> 
            <strong><FontAwesomeIcon icon={faBuilding} /> Empresa</strong>
            <p>{application.jobPost?.restaurant?.name || 'No especificada'}</p>
          </div>
          <div className="application-detail__offer-info-container">
            <strong><FontAwesomeIcon icon={faStore} /> Establecimiento</strong>
            <p>{application.jobPost?.restaurant?.format || 'No especificado'}</p>
          </div>
          <div className="application-detail__offer-info-container"> 
            <strong><FontAwesomeIcon icon={faBriefcase} /> Posición</strong>
            <p>{application.jobPost?.position || 'No especificada'}</p>
          </div>
          <div className="application-detail__offer-info-container">
            <strong><FontAwesomeIcon icon={faClock} /> Experiencia Requerida</strong>
            <p>{application.jobPost?.yearsOfExperience || 0} años</p>
          </div>  
        </div>
      </div>

      <div className='application-detail__answers-container'>
        <h3><FontAwesomeIcon icon={faFileAlt} /> Respuestas del Candidato</h3>
        
        {application.jobPost?.questions && application.jobPost.questions.length > 0 ? (
          <div>
            {application.jobPost.questions.map((question, index) => (
              <div className="application-detail__question-container" key={question.id || index}>
                <h4><FontAwesomeIcon icon={faQuestionCircle} /> {question.question}</h4>
                {question.answers && question.answers.length > 0 ? (
                  question.answers.map((answer, answerIndex) => (
                    <div key={answer.id || answerIndex} className='application-detail__answers-box'>
                      <p><FontAwesomeIcon icon={faComment} /> {answer.answer}</p>
                    </div>
                  ))
                ) : (
                  <div className='application-detail__answers-box'>
                    <p style={{ color: '#6c757d', fontStyle: 'italic' }}>
                      <FontAwesomeIcon icon={faComment} /> El candidato no ha respondido esta pregunta aún.
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div style={{ textAlign: 'center', padding: '2rem' }}>
            <FontAwesomeIcon icon={faFileAlt} style={{ fontSize: '2rem', marginBottom: '1rem', color: '#fb5424' }} />
            <p style={{ color: '#6c757d' }}>
              Esta oferta de trabajo no incluye preguntas específicas para los candidatos.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ApplicationDetail;
